export default (props) => (
  <svg
    width="139"
    height="45"
    viewBox="0 0 139 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#clip0_3808_16246)">
      <path
        d="M9.78969 29.0594C9.92729 29.2379 10.0728 29.4057 10.1972 29.5921C11.0347 30.7852 12.1086 31.7908 13.3513 32.5455C14.594 33.3002 15.9785 33.7877 17.4176 33.9772C18.8568 34.1667 20.3193 34.0541 21.713 33.6466C23.1068 33.239 24.4016 32.5454 25.5158 31.6092C26.6301 30.6731 27.5396 29.5149 28.1871 28.2075C28.8347 26.9 29.2062 25.4718 29.2782 24.0127C29.3502 22.5537 29.1212 21.0954 28.6057 19.7298C28.0901 18.3642 27.2991 17.1209 26.2826 16.0782C25.3226 15.0767 24.1741 14.2774 22.9042 13.7271C21.6342 13.1767 20.2682 12.8863 18.8856 12.8726C17.503 12.859 16.1315 13.1225 14.8511 13.6477C13.5707 14.1729 12.4069 14.9493 11.4276 15.9317C2.74324 24.5104 12.6157 38.5703 22.2076 40.7223C22.5834 40.8075 22.9512 40.9433 23.3216 41.0552V41.2363C22.4482 41.4332 21.5649 41.5826 20.6756 41.6837C18.1592 41.8462 15.6481 41.7583 13.219 40.9806C11.2513 40.3728 9.39824 39.4384 7.73635 38.216C4.97787 36.2092 2.8153 33.4833 1.48138 30.3315C0.147455 27.1797 -0.307323 23.7215 0.165985 20.3289C0.635962 16.3589 2.39487 12.6561 5.16968 9.79536C8.18618 6.62596 11.9065 4.62312 16.2514 4.14105C21.9377 3.5125 27.0499 4.94006 31.363 8.90047C34.5383 11.8302 36.3482 15.4337 37.2372 19.6418C38.6502 26.3242 35.1707 33.9467 28.0157 36.5701C22.7051 38.517 17.802 37.5795 13.383 34.0266C11.9753 32.8973 10.9248 31.4777 10.0146 29.9357C9.87172 29.696 9.75 29.4376 9.63093 29.1873L9.78969 29.0594Z"
        fill="black"
      />
      <path
        d="M49.5072 10.1735H44.2151V26.5212H47.8825V20.5579H49.5125C53.6218 20.5579 55.7387 19.0664 55.7387 15.4975C55.7387 11.9286 53.6165 10.1735 49.5072 10.1735ZM49.3828 17.2633H47.8772V13.468H49.3828C51.2536 13.468 52.0289 13.9634 52.0289 15.5002C52.0289 17.0369 51.2536 17.2633 49.3828 17.2633Z"
        fill="black"
      />
      <path
        d="M62.5041 10.1735L56.2039 26.5212H59.9454L61.152 23.3518H67.3279L68.5318 26.5212H72.448L66.1504 10.1735H62.5041ZM62.3083 20.2063L64.2532 14.5574L66.1716 20.2063H62.3083Z"
        fill="black"
      />
      <path
        d="M74.3533 18.3475C74.3533 23.3279 77.8461 26.8196 83.0641 26.8196C84.7126 26.8196 86.3849 26.4734 87.3957 25.8288V22.1374C86.195 22.9463 84.7788 23.3698 83.334 23.3519C80.1111 23.3519 78.1424 21.4449 78.1424 18.3475C78.1424 15.25 80.1111 13.3457 83.334 13.3457C84.7782 13.3288 86.1939 13.7512 87.3957 14.5575V10.8687C86.3849 10.2242 84.7126 9.87798 83.0641 9.87798C77.8355 9.87798 74.3533 13.3696 74.3533 18.3475Z"
        fill="black"
      />
      <path
        d="M96.7497 10.1735H93.0823V26.5212H96.7497V10.1735Z"
        fill="black"
      />
      <path
        d="M106.766 20.0812H111.544V16.7893H106.766V13.468H112.725V10.1735H103.098V26.5212H106.766V20.0812Z"
        fill="black"
      />
      <path
        d="M121.173 10.1735H117.506V26.5212H121.173V10.1735Z"
        fill="black"
      />
      <path
        d="M134.949 13.3457C136.392 13.3284 137.807 13.7508 139.008 14.5575V10.8687C138 10.2242 136.327 9.87798 134.679 9.87798C129.461 9.87798 125.965 13.3696 125.965 18.3475C125.965 23.3253 129.453 26.8196 134.684 26.8196C136.333 26.8196 138.005 26.4734 139.013 25.8288V22.1374C137.812 22.9468 136.394 23.3703 134.949 23.3519C131.726 23.3519 129.757 21.4449 129.757 18.3475C129.757 15.25 131.718 13.3457 134.949 13.3457Z"
        fill="black"
      />
      <path
        d="M50.9602 33.2222L49.661 28.7185H48.3591L47.089 33.2435L45.8718 28.7185H44.2207L46.2529 35.7471H47.6817L48.9836 31.23L50.2616 35.7471H51.6905L53.7227 28.7185H52.1456L50.9602 33.2222Z"
        fill="black"
      />
      <path
        d="M59.642 28.5906C57.4828 28.5906 55.9692 30.1007 55.9692 32.2314C55.9692 34.3621 57.4828 35.8748 59.642 35.8748C61.8011 35.8748 63.312 34.3621 63.312 32.2314C63.312 30.1007 61.7985 28.5906 59.642 28.5906ZM59.642 34.4153C58.4142 34.4153 57.5992 33.5417 57.5992 32.2314C57.5992 30.921 58.4142 30.0474 59.642 30.0474C60.8697 30.0474 61.6821 30.921 61.6821 32.2314C61.6821 33.5417 60.8591 34.4153 59.642 34.4153Z"
        fill="black"
      />
      <path
        d="M71.1544 30.9637C71.1544 29.4935 70.2548 28.7185 68.5322 28.7185H65.5686V35.7471H67.1562V33.2116H68.0771L69.7361 35.7471H71.6413L69.7917 33.0305C70.6887 32.7109 71.1544 32.0184 71.1544 30.9637ZM68.4687 31.8373H67.1457V30.1327H68.4687C69.2281 30.1327 69.5589 30.3671 69.5589 30.985C69.5589 31.6029 69.2281 31.8373 68.4687 31.8373Z"
        fill="black"
      />
      <path
        d="M79.3146 28.7185H77.4121L74.9459 31.7307V28.7185H73.3689V35.7471H74.9459V32.6363L77.3591 35.7471H79.3463L76.5336 32.1143L79.3146 28.7185Z"
        fill="black"
      />
      <path
        d="M83.4034 28.7185H81.0854V35.7471H82.6731V33.2968H83.414C85.1815 33.2968 86.0891 32.5404 86.0891 31.0063C86.0891 29.4722 85.171 28.7185 83.4034 28.7185ZM83.3505 31.8799H82.6625V30.1327H83.3505C84.1443 30.1327 84.483 30.3458 84.483 31.0063C84.483 31.6668 84.1443 31.8799 83.3505 31.8799Z"
        fill="black"
      />
      <path
        d="M89.7748 28.7185H88.1978V35.7471H92.5875V34.3089H89.7748V28.7185Z"
        fill="black"
      />
      <path
        d="M96.3582 28.7185L93.6487 35.7471H95.2575L95.7867 34.3835H98.4328L98.962 35.7471H100.645L97.9221 28.7185H96.3582ZM96.2736 33.0305L97.1097 30.6015L97.9326 33.0305H96.2736Z"
        fill="black"
      />
      <path
        d="M102.402 32.2314C102.402 34.362 103.905 35.8748 106.146 35.8748C106.79 35.8961 107.428 35.7492 107.999 35.4487V33.8507C107.483 34.202 106.874 34.3878 106.252 34.3833C104.868 34.3833 104.021 33.563 104.021 32.2314C104.021 30.8997 104.868 30.0794 106.252 30.0794C106.874 30.0749 107.483 30.2607 107.999 30.612V29.014C107.427 28.7156 106.79 28.5698 106.146 28.5905C103.905 28.5905 102.402 30.1007 102.402 32.2314Z"
        fill="black"
      />
      <path
        d="M112.044 32.8707H113.936V31.4644H112.044V30.1327H114.444V28.7185H110.467V35.7471H114.561V34.3302H112.044V32.8707Z"
        fill="black"
      />
      <path
        d="M119.802 31.5816L118.913 31.3791C118.14 31.2087 117.897 31.0276 117.897 30.6654C117.897 30.1966 118.289 29.9729 119.072 29.9729C119.84 29.9614 120.591 30.1965 121.218 30.6441V29.0887C120.559 28.735 119.818 28.5632 119.072 28.5906C117.325 28.5906 116.309 29.3337 116.309 30.7932C116.309 31.8799 116.87 32.4978 118.162 32.796L119.019 32.9985C119.789 33.1796 120.011 33.4033 120.011 33.7655C120.011 34.2662 119.601 34.4899 118.786 34.4899C117.916 34.5021 117.066 34.2209 116.373 33.6909V35.2676C116.923 35.6405 117.812 35.8642 118.818 35.8642C120.625 35.8642 121.609 35.1398 121.609 33.6057C121.588 32.4978 121.059 31.8692 119.802 31.5816Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_3808_16246">
        <rect
          width="139"
          height="37.7531"
          fill="white"
          transform="translate(0 4)"
        />
      </clipPath>
    </defs>
  </svg>
)
